import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Tooltip } from "antd";

import { switchWorkspace, getWorkspaceDefaultFilter, getUsers, getWorkspaceById } from '../../../../actions';
import { getWorkspacePalette } from '../../../../js/helper';
import { getWorkspaceNotifications } from "../../../../redux/state-areas/notifications/actions";
import { getWorkspaceDashboardData } from "../../../../actions/WorkspaceActions";
import { useIntl } from "react-intl";
import { clearOpenedTaskId, getDashboardTasksAction } from "../../../../redux/tasks/actions";

const SwitchWorkspacePanel = (props) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [workspaces, setWorkspaces] = useState(props.workspaces);

  const { toggleWorkspacePanel } = props;

  useEffect(() => {
    setWorkspaces(props.workspaces);
  }, [props.workspaces]);

  return (
    <>
      <div className={"switch-workspace-nav"}>
        <div style={{
          width: 'auto',
          alignSelf: 'center'
        }}>
          {workspaces && workspaces?.map((workspace, i) => {
            const iconLetters = workspace.title?.slice(0, 2).toUpperCase() || '';
            const palette = getWorkspacePalette(workspace.title || '');
            return (
              <Tooltip placement="right" title={workspace.title || ''} key={iconLetters + i}>
                <div
                  key={iconLetters + i}
                  className={'circle-letter'}
                  onClick={ () => {
                    props?.setIsLoading(true);

                    dispatch(switchWorkspace(workspace, async() => {
                      sessionStorage.setItem("workspaceId", workspace._id);
                      localStorage.setItem("workspaceId", workspace._id);
                      sessionStorage.setItem("organization", workspace.organization);
                      localStorage.setItem("organization", workspace.organization);
                      await Promise.all([
                        dispatch(getWorkspaceDashboardData()),
                        dispatch(getWorkspaceById()),
                        dispatch(getWorkspaceDefaultFilter(workspace._id)),
                        dispatch(getUsers(workspace._id)),
                        dispatch(getWorkspaceNotifications()),
                        dispatch(clearOpenedTaskId()),
                        dispatch(getDashboardTasksAction(workspace._id))
                      ]);
                      navigate('/', { replace: true });
                      toggleWorkspacePanel();
                      props?.setIsLoading(false);
                    }));
                  }}
                  style={{ background: palette.bg, border: `1px solid ${palette.border}`, color: palette.text }}>
                  {iconLetters}
                </div>
              </Tooltip>
            );
          }
          )}
        </div>
        <Tooltip placement="right" title={intl.formatMessage({ id: 'CREATE_WORKSPACE', defaultMessage: 'Create Workspace' })}>
          <div onClick={() => navigate('/create-workspace')}>
            <img src="/images/icons/workspaceAdd.svg" alt='img' />
          </div>
        </Tooltip>
      </div>
    </>
  )
}

export default SwitchWorkspacePanel
